import styled, { css } from 'styled-components'

export const NotificationStyled = styled.div`
  display: flex;
  width: 100%;
  padding: 1.2rem 1.6rem;
  border-radius: 0.5rem;
  align-items: center;
  margin: ${(props) => (props.margin ? '3rem 0' : '0')};

  ${(props) =>
    props.notificationType === 'green'
      ? css`
          background-color: ${(props) => props.theme.paleGreen};
          border: ${(props) => props.theme.lightGreenBorder};
        `
      : props.notificationType === 'yellow'
      ? css`
          background-color: ${(props) => props.theme.lightYellow};
          border: ${(props) => props.theme.yellowBorder};
        `
      : props.notificationType === 'blue'
      ? css`
          background-color: ${(props) => props.theme.lightBlue2};
          border: ${(props) => props.theme.blueBorder};
        `
      : props.notificationType === 'red'
      ? css`
          background-color: ${(props) => props.theme.lightRed};
          border: ${(props) => props.theme.redBorderThick};
        `
      : ''}

  .notification-icon {
    align-self: start;
    min-width: 1.6rem; 
    width: 1.6rem;
    height: 1.6rem;
    margin-right: 1.2rem;
    margin-top: 0.2rem;
  }
`

export const NotificationContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media only screen and (min-width: ${(props) => props.theme.tablet}) {
    flex-direction: ${(props) => props.desktopDirection || 'row'};
    align-items: ${(props) =>
      props.desktopDirection === 'column' ? 'stretch' : 'center'};
  }

  .notification-cta {
    font-family: 'AnPostSansBold', sans-serif;
    align-self: start;
    display: flex;
    gap: 0.8rem;
    align-items: center;
    margin-top: 0.8rem;
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${(props) => props.theme.black};
    text-decoration: none;

    @media only screen and (min-width: ${(props) => props.theme.tablet}) {
      margin-top: ${(props) =>
        props.desktopDirection === 'column' ? '0.8' : '0'};
      margin-left: ${(props) =>
        props.desktopDirection === 'column' ? '0' : '1.2rem'};
      align-self: ${(props) =>
        props.desktopDirection === 'column' ? 'start' : 'stretch'};
      font-size: 1.6rem;
    }

    svg {
      vertical-align: middle;
    }
  }
`

export const NotificationTextWrapper = styled.div`
  flex: 1 1 calc(100% - 3.2rem);

  @media only screen and (min-width: ${(props) => props.theme.tablet}) {
    flex: 1;
  }

  p,
  a {
    margin-bottom: 0;
    color: ${(props) => props.theme.black};
    font-size: 1.3rem;
    line-height: 2.2rem;

    @media only screen and (min-width: ${(props) => props.theme.tablet}) {
      font-size: 1.2rem;
      line-height: 1.8rem;
    }

    &:first-of-type {
      font-weight: 700;
    }
  }
`
